import { db } from "./firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

export async function claimChunk(
  chunkX: number,
  chunkZ: number,
  userId: string
) {
  const ref = doc(db, "chunks", `${chunkX}_${chunkZ}`);
  const snap = await getDoc(ref);

  if (snap.exists()) {
    throw new Error("Chunk already claimed.");
  }

  await setDoc(ref, {
    owner: userId,
    type: "normal",
    claimedAt: serverTimestamp(),
    blocks: {},
  });
}

export async function getChunkOwner(
  chunkX: number,
  chunkZ: number
): Promise<string | null> {
  const ref = doc(db, "chunks", `${chunkX}_${chunkZ}`);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data().owner : null;
}

export async function saveChunkBlocks(
  chunkX: number,
  chunkZ: number,
  blocks: Record<string, number>
) {
  const ref = doc(db, "chunks", `${chunkX}_${chunkZ}`);
  await setDoc(ref, { blocks }, { merge: true });
}
